var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUniversity(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7559 4.82581C10.7559 3.76494 10.3344 2.74752 9.58429 1.99738C8.83414 1.24723 7.81673 0.825806 6.75586 0.825806H0.755859V15.8258H7.75586C8.55151 15.8258 9.31457 16.1419 9.87718 16.7045C10.4398 17.2671 10.7559 18.0302 10.7559 18.8258M10.7559 4.82581V18.8258M10.7559 4.82581C10.7559 3.76494 11.1773 2.74752 11.9274 1.99738C12.6776 1.24723 13.695 0.825806 14.7559 0.825806H20.7559V15.8258H13.7559C12.9602 15.8258 12.1971 16.1419 11.6345 16.7045C11.0719 17.2671 10.7559 18.0302 10.7559 18.8258",
    stroke: "#1B2028",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUniversity);
export default __webpack_public_path__ + "static/media/university.6cd62189be0f16dc5b9a59436904899c.svg";
export { ForwardRef as ReactComponent };